"use client"
import { useState } from "react"
import { Phone, Mail,Clock, User, Users, FileText, Home } from "lucide-react"

export default function CenterPage() {
  const [activeTab, setActiveTab] = useState("HOME")

  const tabs = [
    { id: "HOME", label: "HOME", icon: Home },
    { id: "WORKROOM_PHONE_NUMBERS", label: "WORKROOM PHONE NUMBERS", icon: Phone },
    { id: "EMERGENCY_AFTER_HOURS", label: "EMERGENCY AFTER HOURS", icon: Clock },
    { id: "REGIONAL_MANAGERS", label: "REGIONAL MANAGERS", icon: Users },
    { id: "FORMS", label: "FORMS", icon: FileText },
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case "HOME":
        return <HomeContent />
      case "WORKROOM_PHONE_NUMBERS":
        return <WorkroomPhoneNumbersContent />
      case "EMERGENCY_AFTER_HOURS":
        return <EmergencyAfterHoursContent />
      case "REGIONAL_MANAGERS":
        return <RegionalManagersContent />
      case "FORMS":
        return <FormsContent />
      default:
        return <HomeContent />
    }
  }

  return (
    <div className="h-full flex flex-col bg-white">
      {/* ACS Header Logo - Clean like original */}
      <div className="bg-white p-4 border-b border-gray-200">
        <div className="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="200" height="50" viewBox="0 0 456.5 105" className="h-12">
            <polygon
              points="48.67 21.03 39.48 27.7 39.48 27.7 27.37 36.5 15.31 45.26 8.74 50.03 8.74 40.49 27.45 26.9 48.67 11.49 69.88 26.9 88.59 40.49 88.59 50.03 82.03 45.26 69.97 36.5 57.86 27.7 57.86 27.7 48.67 21.03"
              fill="#004261"
            />
            <path
              d="m17,94.37l6.86-9.37h16.14l-1.66,9.38h-21.34Zm25.49-9.37h12.35l.89,9.38h-14.12l.88-9.38Zm14.82,0h16.16l6.82,9.38h-21.29l-1.69-9.38Zm-31.68-2.45l5.83-8h10.41l-.51,2.94-.9,5.09-14.83-.03Zm17.85-8h10.37l.3,3.18.46,4.85h-11.88l.45-4.85.3-3.18Zm12,0h10.39l5.83,8h-14.82l-.88-5.09-.52-2.94v.03Zm-22.75-1.77l2.83-3.91h7.31l-.69,3.91h-9.45Zm11.27-3.91h9.3l.36,3.91h-10l.34-3.91Zm10.44,0h7.31l2.83-3.91h-9.43l-.71-3.91Z"
              fill="#00CCFE"
            />
            <g>
              <path
                d="m276.91,68.56c0,6.34-5.12,11.48-11.46,11.51h-34.26v-5.23h34.26c1.65.02,3.24-.65,4.39-1.84,2.44-2.44,2.44-6.4,0-8.84,0,0,0,0,0,0-1.15-1.19-2.74-1.85-4.39-1.83h-22.8c-3.05.06-5.98-1.14-8.11-3.33-4.47-4.49-4.47-11.74,0-16.23,2.12-2.2,5.06-3.42,8.11-3.37h31.53v5.23h-31.53c-3.45-.14-6.37,2.55-6.51,6s2.55,6.37,6,6.51c.17,0,.33,0,.5,0h22.8c6.32.03,11.43,5.14,11.46,11.46v-.04Zm-51.09,11.51h-34.25c-6.3.03-11.43-5.04-11.46-11.34,0-.04,0-.08,0-.12v-17.79c0-6.32,5.12-11.45,11.44-11.46,0,0,.01,0,.02,0h34.25v5.23h-34.25c-3.43.02-6.21,2.8-6.23,6.23v17.79c.03,3.43,2.8,6.2,6.23,6.23h34.25s0,5.23,0,5.23Zm-61.7-17.26l-8.42-16.12c-.42-.8-1.41-1.12-2.21-.7-.3.16-.54.4-.7.7l-8.6,16.11c-.35.55-.35,1.25,0,1.8.32.57.92.9,1.57.87h16.79c.63.01,1.22-.32,1.54-.87.35-.55.35-1.24,0-1.79h.03Zm15.72,17.26h-6.51c-.31-.54-1.56-2.87-3.73-7-.64-1.43-2.09-2.33-3.66-2.27h-23.45c-1.57-.09-3.04.78-3.72,2.2l-3.6,7h-6.57l21.58-40.71h8.08c.47.85,7.66,14.42,21.58,40.71v.07Z"
                fill="#004261"
              />
              <rect x="110.11" y="28.39" width="1.81" height="67.61" fill="#004261" />
            </g>
          </svg>
          <div className="ml-3 text-gray-600">
            <div className="text-sm">Commercial &</div>
            <div className="text-sm">Residential</div>
            <div className="text-sm font-medium">Flooring Specialists</div>
          </div>
        </div>
      </div>

      {/* Horizontal Tab Navigation - Exactly like original */}
      <div className="bg-[#004261] text-white w-full">
      <div className="flex w-full">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 px-4 py-3 text-sm font-medium whitespace-nowrap text-center transition-colors uppercase ${
              activeTab === tab.id
                ? "bg-[#00CCFE] text-[#004261] font-bold"
                : "text-white hover:bg-[#00283b]"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>


      {/* Tab Content */}
      <div className="flex-1 overflow-y-auto bg-white">{renderTabContent()}</div>
    </div>
  )
}

// Home Content Component
function HomeContent() {
  return (
    <main className="container mx-auto px-4">
      {/* Disaster Relief Section */}
      <section className="text-center py-10">
        <h2 className="text-3xl font-bold text-[#004261] uppercase mb-6">
          How To Enter a Pro Flooring Measure in Order Up
        </h2>
        <div className="w-16 h-1 bg-[#00CCFE] mx-auto mb-6"></div>   
        <div className="flex justify-center mb-6">
          <div className="aspect-video w-full max-w-5xl mx-auto">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/AGl2nNVsw4I?si=dybosrr3vUGjzpzW"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
        <a
          className="inline-block bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
          target="_blank"
          rel="noopener noreferrer"
          href="https://drive.google.com/file/d/1E2zDX_9DBpJLc7bJ2D5nHVif_IAaGFf2/view?usp=drive_link"
        >
          Download Video
        </a>
      </section>

      {/* Service Partner Section */}
      <section className="text-center bg-gray-100 text-[#004261] py-10 border-y border-gray-400">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold mb-6">Service Partner of the Year</h2>
          <p className="mb-6">
            We are proud to be a long-time partner of Home Depot and to have been selected as a Service Provider of the Year several times. Home Depot sets the bar high for its partners:{" "}
            <q>Exceed customers' expectations</q> by providing world-class design and installation services along with second-to-none customer service. From day one, we've risen to the challenge and shared their vision. We're proud to affiliate with this fine organization.
          </p>
          <div className="flex justify-center">
            <img
              src="/acs-home-depot-awards-4-years-gray-bg.png"
              alt="ACS Provider of the Year for Flooring in 2019, 2020, 2021 & 2023"
              className="max-w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* About ACS & Our Process */}
      <section className="flex flex-col md:flex-row justify-center gap-8 text-center px-4">
  <div className="md:w-1/2 space-y-4">
    <h3 className="text-2xl font-semibold">About ACS</h3>
    <div className="aspect-video">
      <iframe
        src="https://www.youtube.com/embed/I32uvaGhz2Q?controls=1&hd=1&autohide=1&rel=0"
        title="About ACS"
        className="w-full h-full rounded-lg"
        allowFullScreen
      ></iframe>
    </div>
  </div>
  <div className="md:w-1/2 space-y-4">
    <h3 className="text-2xl font-semibold">Our Process</h3>
    <div className="aspect-video">
      <iframe
        src="https://www.youtube.com/embed/vwByUDv2_ls?controls=1&hd=1&autohide=1&rel=0"
        title="Our Process"
        className="w-full h-full rounded-lg"
        allowFullScreen
      ></iframe>
    </div>
  </div>
</section>


      {/* Testimonials */}
      <section className="text-center py-10">
        <h2 className="text-3xl font-bold text-[#004261] mb-10">What Our Customers Say About Us</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              quote:
                "American Carpet South installed the carpet I purchased from Home Depot. They were excellent! I received a call from the office shortly after purchase, and they were able to install the very next day. The installers were on time, very professional, and did an amazing job. My new carpet is beautiful... far exceeded my expectations.",
              author: "Rebecca R. | Google",
            },
            {
              quote:
                "We had a carpet installed on our basement stairs by Caesar. He was very neat and quick; only took one hour to complete the job and that included removing the old carpet. VERY satisfied with the outcome and LOVE our new carpet!!",
              author: "Cap Y. | Google",
            },
            {
              quote:
                "We recently had our entire house carpeted. Our installers were named Wilmer and Orlando and they were from the Albany, NY area. They arrived by 10:00am and worked through the day until about 6:30pm. We are delighted with the carpet. They were meticulous with every aspect of the install.",
              author: "Kathy W. | Yelp",
            },
          ].map((t, idx) => (
            <div key={idx} className="text-left bg-white shadow p-4 rounded-lg">
              <p className="italic mb-4">“{t.quote}”</p>
              <div className="text-right font-semibold text-sm text-gray-600">— {t.author}</div>
            </div>
          ))}
        </div>
      </section>
    </main>
  )
}

// Workroom Phone Numbers Content - With proper background colors like original
function WorkroomPhoneNumbersContent() {
  const workrooms = [
    {
      location: "Albany, NY\nPassaic, NJ\nBaltimore, MD",
      phone: "(973) 405-6400",
    },
    { location: "Atlanta, GA", phone: "(470) 523-1983" },
    { location: "Baltimore CER/WIND T", phone: "(410) 391-6994" },
    { location: "Baltimore CER/WIND T (Lorton, VA)", phone: "(703) 891-2791" },
    { location: "Binghamton; Syracuse/Mattydale, NY", phone: "(607) 722-5224" },
    { location: "Blakeslee, PA", phone: "(973) 405-6400" },
    { location: "Bangor, ME\nHudson, NH\nSpringfield, MA", phone: "(973) 405-6400" },
    { location: "Chattanooga, TN", phone: "(470) 523-1983" },
    { location: "Cinnaminson, NJ", phone: "(973) 405-6400" },
    { location: "Erie, PA", phone: "(814) 464-0280" },
    // { location: "Fredericksburg, VA", phone: "(540) 752-5200" },
    { location: "Harrisburg, PA", phone: "(973) 405-6400" },
    { location: "New Windsor, NY", phone: "(845) 563-7200" },
    { location: "Ocean City, MD", phone: "(443) 513-4900" },
    // { location: "Old Bridge, NJ", phone: "(732) 479-0000" },
    { location: "Portland, ME", phone: "(207) 831-0470" },
    { location: "Pittsburgh, PA", phone: "(973) 405-6400" },
    { location: "Rochester, NY\nBuffalo, NY", phone: "(716) 633-2686" },
    { location: "Waterbury, CT", phone: "(203) 753-7700" },
    { location: "West Haven, CT", phone: "(203) 795-3169" },
  ]

  return (
    <div className="p-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-[#004261] mb-2 uppercase tracking-wide">WORKROOM PHONE NUMBERS</h1>
        <div className="w-16 h-1 bg-[#00CCFE] mx-auto mb-6"></div>
        <p className="text-gray-600 text-lg">Find the contact you need.</p>
      </div>

      <div className="max-w-6xl mx-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b-2 border-gray-300">
              <th className="text-left py-4 px-6 text-lg font-bold text-[#004261] uppercase">Workroom Location</th>
              <th className="text-left py-4 px-6 text-lg font-bold text-[#004261] uppercase">Phone Number</th>
            </tr>
          </thead>
          <tbody>
            {workrooms.map((workroom, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-[#B8E6E6]" : "bg-white"}>
                <td className="py-4 px-6 text-sm text-gray-900 whitespace-pre-line font-medium">{workroom.location}</td>
                <td className="py-4 px-6 text-sm">
                  <a href={`tel:${workroom.phone}`} className="text-[#004261] hover:text-[#00CCFE] font-medium">
                    {workroom.phone}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

// Emergency After Hours Content - With proper background colors like original
function EmergencyAfterHoursContent() {
  const emergencyContacts = [
    {
      location: "Albany\nNorth East Industrial Park\nBuilding 3 Avenue B\Guilderland Center, NY 12085",
      phone: "(973) 765-6177",
    },
    {
      location: "Atlanta\n1650 Airport Rd.\nSuite 103\nKennesaw, GA 30144",
      phone: "(973) 765-6177",
    },
    {
      location: "Baltimore\n4240 Shannon Dr\nSuite A-C\nBaltimore, MD 21213",
      phone: "(973) 765-6177",
    },
    {
      location: "Bangor\n242 Miller Street\nBangor, ME 04401",
      phone: "(973) 765-6177",
    },
    {
      location: "Blakeslee\n137 Market Way\nTobyhanna, PA 18466",
      phone: "(973) 765-6177",
    },
    {
      location: "Chattanooga\n4295 Cromwell Rd.\nSuite 416\nChattanooga, TN 37421",
      phone: "(973) 765-6177",
    },
    {
      location: "Cinnaminson\n1714 Bannard St.\nUnit 2\nCinnaminson, NJ 08077",
      phone: "(973) 765-6177",
    },
    {
      location: "Hudson\n11 Flagstone Dr\nHudson, NH 03051",
      phone: "(973) 765-6177",
    },
     {
      location: "Harrisburg\n7917 Derry St\nSuite 115\nHarrisburg, PA 17111",
      phone: "(973) 765-6177",
    },
     {
      location: "Landover\n8363 Ardwick Ardmore Rd\nLandover, MD 20785",
      phone: "(973) 765-6177",
    },
    {
      location: "Passaic\n347 Broadway\nPassaic, NJ 07055",
      phone: "(973) 765-6177",
    },
    {
      location: "Pittsburgh\n800 Hope Hollow Rd\nBuilding 4\nPittsburgh, PA 15106",
      phone: "(973) 765-6177",
    },
     {
      location: "Springfield\n88 EE Industry Ave.\nSpringfield, MA 01104",
      phone: "(973) 765-6177",
    },
    {
      location: "Binghamton\n2 Gaines St\nBinghamton, NY 13905",
      phone: "(607) 624-1461",
    },
    {
      location: "Mattydale/Syracuse\n6717 Pickard Drive\nMattydale, NY 13211",
      phone: "(607) 624-1461",
    },
     {
      location: "Baltimore CER/WIND T\n6925 Golden Ring Rd\nBaltimore, MD 21237",
      phone: "(443) 677-5503",
    },
     {
      location: "Baltimore CER/WIND T\n7409 A Lockport Pl\nLorton, VA 22079",
      phone: "(571) 283-3468",
    },
     {
      location: "Buffalo\n3852 Broadway\nCheektowaga, NY 14227",
      phone: "(716) 583-1466",
    },
     {
      location: "Rochester\n18 Industrial Park Circle\nRear\nRochester, NY 14624",
      phone: "(716) 583-1466",
    },
    {
      location: "Erie\n1910 West 21st\nUnit B\nErie, PA 16502",
      phone: "(814) 323-6165",
    },
    //  {
    //   location: "Fredericksburg\n119 Juliad Ct\nSuite 101\nFredericksburg, VA 22406",
    //   phone: "(540) 455-2554",
    // },
    //  {
    //   location: "Old Bridge\n3160 Bordentown Ave\nOld Bridge, NJ 08857",
    //   phone: "(908) 421-2280",
    // },
     {
      location: "New Windsor\n3 Ruscitti Road\nSuite 300\nNew Windsor, NY 12553",
      phone: "(203) 565-6910",
    },
    {
      location: "Ocean City\n10550 Friendship Rd\nUnit B\nBerlin, MD 21811",
      phone: "(443) 523-5190",
    },
    {
      location: "Portland\n12 Rice St.\nUnit 4\nPortland, ME 04103",
      phone: "(207) 831-0472",
    },
     {
      location: "Waterbury\n1604 Thomasten Ave.\nUnit A\nWaterbury, CT 06704",
      phone: "(860) 719-5866",
    },
     {
      location: "West Haven\n281 Dogburn Rd.\nWest Haven, CT 06516",
      phone: "(203) 427-3109",
    },
  ]

  return (
    <div className="p-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-[#004261] mb-2 uppercase tracking-wide">EMERGENCY AFTER HOURS</h1>
        <div className="w-16 h-1 bg-[#00CCFE] mx-auto mb-6"></div>
        <p className="text-gray-600 text-lg">Find the contact you need.</p>
      </div>

      <div className="max-w-6xl mx-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b-2 border-gray-300">
              <th className="text-left py-4 px-6 text-lg font-bold text-[#004261] uppercase">Workroom Location</th>
              <th className="text-left py-4 px-6 text-lg font-bold text-[#004261] uppercase">Phone Number</th>
            </tr>
          </thead>
          <tbody>
            {emergencyContacts.map((contact, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-[#B8E6E6]" : "bg-white"}>
                <td className="py-4 px-6 text-sm text-gray-900 whitespace-pre-line font-medium">{contact.location}</td>
                <td className="py-4 px-6 text-sm">
                  <a href={`tel:${contact.phone}`} className="text-[#004261] hover:text-[#00CCFE] font-medium">
                    {contact.phone}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

// Regional Managers Content - With proper background colors like original
function RegionalManagersContent() {
  const managers = [
    {
      name: "Michael Freidel",
      title: "Field Support Manager",
      territory: "NJ & Eastern PA",
      email: "michael_freidel@acsouth.com",
      phone: "(973) 330-0605",
      hasPhoto: true,
       photo: "/RigonalManagers/michael-freidel.jpg",
    },
    {
      name: "Sean Boston",
      title: "Field Support Manager",
      territory: "Pittsburgh, Harrisburg, Buffalo, Syracuse, Binghamton, and Rochester",
      email: "sean_boston@acsouth.com",
      phone: "(973) 330-5988",
      hasPhoto: true,
      photo: "/RigonalManagers/sean-boston.jpg",
    },
    {
      name: "Rita Alcantara",
      title: "Field Support Manager",
      territory: "NYC/BOROS, CT, Hudson Valley",
      email: "rita_alcantara@acsouth.com",
      phone: "(973) 330-5987",
      hasPhoto: true,
       photo: "/RigonalManagers/rita-alcantara.jpg",
    },
    {
      name: "Brenna Campbell",
      title: "Field Support Manager",
      territory: "New England, Albany NY",
      email: "brenna_campbell@ACSOUTH.COM",
      phone: "(973) 330-5989",
      hasPhoto: true,
       photo: "/RigonalManagers/brenna-campbell.jpg",
    },
    {
      name: "Alan Koontz",
      title: "Field Support Manager",
      territory: "Maryland, Virginia and West Virginia",
      email: "alan_koontz@acsouth.com",
      phone: "(973) 330-5985",
      hasPhoto: true,
       photo: "/RigonalManagers/alan-koontz.jpg",
    },
    {
      name: "Shelley Garvin",
      title: "Field Support Manager",
      territory: "Mid-South Atlanta/North-South",
      email: "shelley_garvin@acsouth.com",
      phone: "404-365-3094",
      hasPhoto: true,
       photo: "/RigonalManagers/shelly-garvin-headshot.jpg",
    },
    // {
    //   name: "Wes Bass",
    //   title: "Field Support Manager",
    //   territory: "Philadelphia/Delaware",
    //   email: "cameron_bass@acsouth.com",
    //   phone: "(973) 384-1146",
    //   hasPhoto: true,
    //    photo: "/RigonalManagers/cameron-bass.jpg",
    // },
  ]

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6 lg:mb-8">
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">REGIONAL MANAGERS</h1>
          <div className="w-16 h-1 bg-[#00CCFE] mx-auto mb-6"></div>   
          <p className="text-gray-600">Find the contact you need.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8">
          {managers.map((manager, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="md:flex h-full min-h-[220px]">
    {/* Left Image Panel */}
    <div className="md:w-1/3 bg-gray-100 p-0 flex items-center justify-center h-full">
      {manager.hasPhoto && manager.photo ? (
        <img
          src={manager.photo}
          alt={manager.name}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-20 h-20 lg:w-24 lg:h-24 bg-gray-300 rounded-full flex items-center justify-center">
          <User className="h-10 w-10 lg:h-12 lg:w-12 text-gray-500" />
        </div>
      )}
    </div>

    {/* Right Content Panel */}
    <div className="md:w-2/3 p-4 lg:p-6 flex flex-col justify-between h-full">
      <div>
        <h2 className="text-lg lg:text-xl font-bold text-gray-900 mb-1">{manager.name}</h2>
        <p className="text-gray-600 mb-2 text-sm lg:text-base">{manager.title}</p>
        <p className="text-sm text-gray-700 mb-4">
          <span className="font-semibold uppercase">Territory: </span>
          {manager.territory}
        </p>
      </div>
      <div className="space-y-2">
        {manager?.email?.trim() && (
    <div className="flex items-center">
      <Mail className="h-4 w-4 text-gray-400 mr-2" />
      <a
        href={`mailto:${manager.email}`}
        className="text-blue-600 hover:text-blue-800 text-sm"
      >
        {manager.email}
      </a>
    </div>
  )}

  {manager?.phone?.trim() && (
    <div className="flex items-center">
      <Phone className="h-4 w-4 text-gray-400 mr-2" />
      <a
        href={`tel:${manager.phone}`}
        className="text-gray-900 text-sm"
      >
        Direct: {manager.phone}
      </a>
    </div>
  )}
      </div>
    </div>
  </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

// Forms Content - With proper background colors like original
function FormsContent() {
  const installationGuides = [
    { name: "Carpet Buying Guide", file: "/forms/carpet-buying-guide-update-5-23.pdf" },
    { name: "Furniture Moving Guide", file: "/forms/Furniture_Moving-09042024-V1.pdf" },
    { name: "Install Preparation Guide", file: "/forms/Install_Preparation-09042024-V1.pdf" },
    { name: "Ceramic Installation Guide", file: "/forms/Ceramic_Installation_Guide-09042024-V2.pdf" },
    { name: "Laminate Installation Guide", file: "/forms/Laminate_Installation_Guide-09042024-V2.pdf" },
    { name: "Vinyl Installation Guide", file: "/forms/Vinyl_Installation_Guide-09042024-V2.pdf" },
    { name: "Wood Installation Guide", file: "/forms/Wood_Installation_Guide-09042024-V4.pdf" },
    { name: "Carpet Installation Guide", file: "/forms/Carpet_Installation_Guide-09042024-V4.pdf" },
  ];

  const specSheets = [
    { name: "Memory Foam PAD SPEC", file: "/forms/tempur.pdf" },
    { name: "Step Ahead with Nike Grind PAD SPEC", file: "/forms/step-ahead.pdf" },
    { name: "Traffic Master 6 PAD SPEC", file: "/forms/tm-6.pdf" },
    { name: "Traffic Master 8 PAD SPEC", file: "/forms/tm-8.pdf" },
    { name: "PrimeComfort Spec Sheet", file: "/forms/prime-comfort.pdf" },
  ];

  return (
    <div className="p-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-[#004261] mb-2 uppercase tracking-wide">FORMS</h1>
        <div className="w-16 h-1 bg-[#00CCFE] mx-auto mb-6"></div>
      </div>

      {/* Installation & Reference Guides */}
      <section className="mb-8 lg:mb-12">
        <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mb-4 lg:mb-6">Installation & Reference Guides</h2>
        <div className="bg-white rounded-lg shadow-md">
          <div className="divide-y divide-gray-200">
            {installationGuides.map((guide, index) => (
              <div key={index} className="p-4 hover:bg-gray-50 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <FileText className="h-5 w-5 text-blue-600 mr-3" />
                    <a
                      href={guide.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-900 font-medium hover:underline hover:text-blue-700"
                    >
                      {guide.name}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Spec & Fact Sheets */}
      <section>
        <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mb-4 lg:mb-6">Spec & Fact Sheets</h2>
        <div className="bg-white rounded-lg shadow-md">
          <div className="divide-y divide-gray-200">
            {specSheets.map((sheet, index) => (
              <div key={index} className="p-4 hover:bg-gray-50 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <FileText className="h-5 w-5 text-green-600 mr-3" />
                    <a
                      href={sheet.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-900 font-medium hover:underline hover:text-green-700"
                    >
                      {sheet.name}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
